export default __webpack_public_path__ + "static/media/SS.d7face78.jpeg";